import axios from 'axios'

export default {
  setSelectedSchoolYear ({ commit }, selectedSchoolYear) {
    commit('setSelectedSchoolYearSuccess', selectedSchoolYear)
  },
  getSchoolYears ({ commit }) {
    commit('getSchoolYearsRequest')
    let url = `/api/school-year/?limit=0`

    return axios
      .get(url)
        .then(function (response) {
          commit('getSchoolYearsSuccess', response.data)
          return response
        })
        .catch(function (error) {
          commit('getSchoolYearsFailure', error)
          throw error
        })
  },
  getOpenSchoolYear ({ commit }) {
    commit('getOpenSchoolYearRequest')
    let url = `/api/school-year/open-school-year/`

    return axios
      .get(url)
      .then(function (response) {
        commit('getOpenSchoolYearSuccess', response.data)
        return response
      })
      .catch(function (error) {
        commit('getOpenSchoolYearFailure', error)
        throw error
      })
  },
  getOverallStatistics ({ commit }, { id }) {
    commit('getOverallStatisticsRequest')
    let url = `/api/school-year/${id}/overall-statistics/`

    return axios
      .get(url)
        .then(function (response) {
          commit('getOverallStatisticsSuccess', response.data)
          return response
        })
        .catch(function (error) {
          commit('getOverallStatisticsFailure', error)
          throw error
        })
  },
}
